import { USER_SETTINGS_AUDIO_KEY } from '@utils/constants';
import { getUserSetting } from '@utils/userSettings-utils';
import { useEffect, useRef } from 'react';

export default function useLessonAudio({
  enableWrong,
  enableCorrect,
  enableDailyGoalReached,
}: {
  enableWrong?: boolean;
  enableCorrect?: boolean;
  enableDailyGoalReached?: boolean;
}) {
  const wrongAudioRef = useRef<HTMLAudioElement>();
  const correctAudioRef = useRef<HTMLAudioElement>();
  const dailyGoalReachedAudioRef = useRef<HTMLAudioElement>();

  useEffect(() => {
    if (enableWrong) {
      wrongAudioRef.current = new Audio('/audio/wrong.mp3');
      wrongAudioRef.current.preload = 'auto';
    }
    if (enableCorrect) {
      correctAudioRef.current = new Audio('/audio/correct.mp3');
      correctAudioRef.current.preload = 'auto';
    }
    if (enableDailyGoalReached) {
      dailyGoalReachedAudioRef.current = new Audio(
        '/audio/daily_goal_reached.mp3',
      );
      dailyGoalReachedAudioRef.current.preload = 'auto';
    }
  }, [enableWrong, enableCorrect, enableDailyGoalReached]);

  function playWrongAudio() {
    const isAudioEnabled = getUserSetting(USER_SETTINGS_AUDIO_KEY);
    if (enableWrong && isAudioEnabled) {
      wrongAudioRef.current?.play();
    }
  }
  function playCorrectAudio() {
    const isAudioEnabled = getUserSetting(USER_SETTINGS_AUDIO_KEY);
    if (enableCorrect && isAudioEnabled) {
      correctAudioRef.current?.play();
    }
  }
  function playDailyGoalReachedAudio() {
    const isAudioEnabled = getUserSetting(USER_SETTINGS_AUDIO_KEY);
    if (enableDailyGoalReached && isAudioEnabled) {
      dailyGoalReachedAudioRef.current?.play();
    }
  }

  return { playCorrectAudio, playWrongAudio, playDailyGoalReachedAudio };
}
